// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"158":"bf9a00b0","944":"89d934ae"}[chunkId] + ".chunk.js";
};